var map = {
	"./modalAssign": 187,
	"./modalAssign.vue": 187
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1324;


//////////////////
// WEBPACK FOOTER
// ./src/custom/calia/dialogs ^\.\/.*$
// module id = 1324
// module chunks = 172